// @ts-check

export const ASSIGNMENT_CREATE_EMPTY_POSTING_ROW =
  'ASSIGNMENT_CREATE_EMPTY_POSTING_ROW'
export const ASSIGNMENT_REMOVE_ITEM = 'ASSIGNMENT_REMOVE_ITEM'
export const ASSIGNMENT_REMOVE_ITEMS = 'ASSIGNMENT_REMOVE_ITEMS'
